const MODEL_VIEWER_LOCALHOST = 'http://localhost:3001'
const MODEL_VIEWER_LIVEHOST = 'https://models.azure-ar.com'

export const MODEL_VIEWER_HOST = (false && window.location.hostname === 'localhost' ? MODEL_VIEWER_LOCALHOST : MODEL_VIEWER_LIVEHOST)
